var map = {
	"./bet-tnc-cn.svg": 2365,
	"./fifa-tnc-cn.svg": 2366,
	"./leaderboard-tnc-cn.svg": 2367,
	"./lucky-tnc-cn.svg": 2368,
	"./term-condition-bm.svg": 2369,
	"./term-condition-cn.svg": 2370,
	"./term-condition-id.svg": 2371,
	"./term-condition.svg": 2372,
	"./term-content.png": 2373,
	"./term-footer.png": 2374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;